// extracted by mini-css-extract-plugin
module.exports = {"btn":"BookNow_btn__3SGIr"};